var e=function(e,s){if(null===e)return e;if(e.classList)e.classList.remove(s);else{var a=new RegExp("(^|\\b)".concat(s.split("·").join("|"),"(\\b|$)"),"gi");e.className=e.className.replace(a," ")}return e};export{e as default};
//# sourceMappingURL=removeClass.mjs.map
